module.exports = __webpack_public_path__ + "static/img/top_right.ff8862cd.png";